import request from './request.js'

/*
* H5获取分享动态
* */
export function getShareData(data) {
    let url = '/dynamic/dynamicH5';
    return request.post(url, data);
}
/*
* H5获取动态评论
* */
export function getCommentListH5(data) {
    let url = '/dynamic/commentListH5';
    return request.post(url, data);
}

/*
* 个人主页信息
* */
export function getUserPageInfo(data) {
    let url = '/account/open/h5/user/homepage?id=' + data.id;
    return request.get(url);
}
/*
* 获取用户最新一条动态
* */
export function getNewOneH5(data) {
    let url = '/dynamic/getNewOneH5';
    return request.post(url,data);
}
